// extracted by mini-css-extract-plugin
export var button = "_hz-0";
export var donut = "_hz-1";
export var donutFill = "_hz-3";
export var donutTrack = "_hz-2";